import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import ReportIcon from "@mui/icons-material/Report";

export const AlertPopUp = (props) => {
  const { show, message, onClose, closeOnTimer } = props;

  useEffect(() => {
    if (closeOnTimer) {
      setTimeout(() => window.location.reload(), 4000);
    }
  });

  return (
    <Dialog
      onClose={!closeOnTimer ? () => onClose() : null}
      open={show}
      sx={{ zIndex: "99999" }}
    >
      <DialogTitle
        sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}
      >
        <ReportIcon />
        Attention
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2">{message}</Typography>
      </DialogContent>
      {!closeOnTimer ? (
        <DialogActions sx={{ alignItems: "right" }}>
          <Button color="primary" autoFocus onClick={onClose}>
            Ok
          </Button>
        </DialogActions>
      ) : null}
    </Dialog>
  );
};
